import { NotificationSeverity } from '../notifications';

export const onMessage =
  'toastr' in window
    ? (message: string, severity: NotificationSeverity) => {
        if (severity === NotificationSeverity.Error) {
          toastr.error(message);
        } else {
          toastr.success(message);
        }
      }
    : undefined;
